import script from "./PreviewProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewProfile.vue?vue&type=script&setup=true&lang=js"

import "./PreviewProfile.vue?vue&type=style&index=0&id=5029ef55&lang=scss"

const __exports__ = script;

export default __exports__